import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import WdSelect from "./wd_select";

class WrappedSelect extends React.Component {
  render () {
    const classes = Object.assign({}, { "form-group": true }, this.props.extraHtmlClasses);
    const selectedValue = this.props.selectedValue;

    const onChange = e => {
      if (e && e.value === (selectedValue || {}).value) {
        return;
      }

      this.props.onChange(e);
    };

    return (
      <div className={classNames(classes)}>
        <h4 onClick={ () => this.input.focus() }>{this.props.title}</h4>
        <WdSelect
          value={selectedValue}
          ref={(input) => this.input = input }
          name="not-used"
          options={this.props.values}
          onChange={onChange}
          isClearable={this.props.clearable}
          isMulti={false}
          placeholder={this.props.placeholder}
          />
      </div>
    );
  }
}

const optionShape = PropTypes.shape({
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
});

WrappedSelect.propTypes = {
  values: PropTypes.arrayOf(optionShape).isRequired,
  selectedValue: optionShape,
  onChange: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  clearable: PropTypes.bool.isRequired,
  extraHtmlClasses: PropTypes.object.isRequired,
  placeholder: PropTypes.string
};

export default WrappedSelect;
